import React from 'react'
import personalData from '../json/personal.json'
import { Row, Col, Container } from 'react-bootstrap'
const personal = () => {

    return (
        <Container>
            <h1>Personal</h1>
            <Row>
                {personalData.map((person) => (
                    <Col key={person.nombre} lg={4} md={6} sm={12}
                    >
                        <div style={{  padding: '20px', 
                        marginBottom: '20px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.25)',
                        borderRadius: '8px', }}
                        >
                            <img
                                src={person.foto}
                                style={{ width: '100%', height: '300px',
                                objectFit: 'cover', borderRadius: '8px', marginBottom: '1em' }}
                                className="img-fluid"
                            />                      
                            <h4 >{person.nombre}</h4>
                            <hr />
                            <p><b>{person.cargo}</b></p>
                           
                            <p>DNI:{person.dni}</p>
                        </div>
                    </Col>
                ))}
            </Row>
        </Container>
    )
}

export default personal